<!--

  ========== 教科研 - 专题活动 ==========

-->
<template>
    <div class="app-container">
        <el-card class="mb15">
            <el-row>
                <el-col v-has-btn="'1,2,3,'" :span="8" class="mb0">
                    <el-button v-has-btn="'1,2,3'" type="primary" @click="handleAdd">新增专题活动</el-button>
                    <el-button v-has-btn="'1,2,3'" type="primary" @click="handleLbAdd">专题活动量表管理</el-button>
                </el-col>
                <el-col :span="16" class="mb0">
<!--                    <div class="pull-right"
                        style="display: flex;align-items: center;transform: translateY(-3px);font-size: 14px;">
                        <el-checkbox @change="getList()" v-model="isSHowMine" size="large" />
                        <div class="ml5" style="white-space: nowrap;">我参与的</div>
                    </div>-->
                </el-col>
            </el-row>
        </el-card>
        <el-card>
            <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px"
                @submit.native.prevent="handleQuery">
                <el-row class="mt15">
                    <el-col :span="6" class="mb0">
                        <el-form-item label="活动状态">
                            <el-select clearable @change="getList()" v-model="queryParams.status" placeholder="请选择">
                                <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                    :value="item.value" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6" class="mb0">
                        <el-form-item label="活动性质">
                            <el-select clearable @change="getList()" v-model="queryParams.nature" placeholder="请选择">
                                <el-option v-for="item in natureList" :key="item.dictKey" :label="item.dictValue"
                                    :value="item.dictKey" />
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" class="mr0 mb0">
                        <el-form-item class="pull-right">
                            <el-input v-model="queryParams.name" placeholder="请输入活动标题" class="input-with-select">
                                <template #append>
                                    <el-button @click="handleQuery" type="primary" icon="el-icon-search" />
                                </template>
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <el-divider />
            <div class="bre9e mt15">
                <el-table v-if="!loading" header-cell-class-name="bgf2" show-overflow-tooltip
                    @current-change="handleCurrentChange" height="calc(100vh - 350px)" v-loading="loading" :data="dataList"
                    highlight-current-row>
                    <el-table-column type="index" align="center" label="序号" width="60" />
                    <el-table-column width="90" align="center" label="活动状态" prop="status">
                        <template #default="scope">
                            <div v-if="scope.row.status === 0">初始阶段</div>
                            <div v-if="scope.row.status === 1">报名阶段</div>
                            <div v-if="scope.row.status === 2">初审阶段</div>
                            <div v-if="scope.row.status === 3">复审阶段</div>
                            <div v-if="scope.row.status === 4">终审阶段</div>
                            <div v-if="scope.row.status === 5">现场评比</div>
                            <div v-if="scope.row.status === 6">活动结束</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="200" label="活动名称" prop="topicName">
                        <template #default="scope">
                            <div :title="scope.row.activityName" style="color: #409efe;" class="text-one cursor">
                                {{ scope.row.activityName }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="120" align="center" label="活动范围" prop="activityNature">
                        <template #default="scope">
                            <div v-if="scope.row.activityNature == 1" class="text-one">普通</div>
                            <div v-if="scope.row.activityNature == 2" class="text-one">名师工作室</div>
                            <div v-if="scope.row.activityNature == 3" class="text-one">名校长工作室</div>
                            <div v-if="scope.row.activityNature == 4" class="text-one">群组</div>
                        </template>
                    </el-table-column>
                    <el-table-column width="160" align="center" label="活动级别" prop="activityLevelName">
                    </el-table-column>
                    <el-table-column width="120" align="center" label="审核模式" prop="checkModeName">
                    </el-table-column>
                    <el-table-column width="260" align="center" label="报名阶段" prop="time">
                        <template #default="scope">
                            <div>
                                {{ timestampToTime(scope.row.beginTime) }}至{{ timestampToTime(scope.row.endTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column width="180" align="center" label="学段•年级•学科">
                        <template #default="scope">
                            <el-text>
                                {{scope.row.periodName?scope.row.periodName:'--'}}•{{scope.row.gradeName?scope.row.gradeName:'--'}}•{{scope.row.subjectName?scope.row.subjectName:'--'}}
                            </el-text>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" width="100px"
                                     label="操作" align="center"
                                     class-name="small-padding fixed-width">
                        <template #default="scope">
                            <el-popover placement="bottom" trigger="click" :width="120" popper-style="padding: 5px 0 0">
                                <template #reference>
                                    <el-button>操作</el-button>
                                </template>
                                <template #default>
                                    <div>
                                        <div class="text-item" v-has-btn="'1,2,3'">
                                            <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                        </div>
                                        <div class="text-item" v-if="this.role==1||this.role==2||this.userId==scope.row.activityLeader">
                                            <el-text type="primary" @click="handleManager(scope.row)">管理</el-text>
                                        </div>
                                        <el-popconfirm confirm-button-text="是" cancel-button-text="否" :icon="InfoFilled"
                                                       icon-color="#626AEF" title="确定删除该活动" @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <div class="text-item" v-has-btn="'1,2'">
                                                    <el-text type="primary" >删除</el-text>
                                                </div>
                                            </template>
                                        </el-popconfirm>

                                    </div>
                                </template>
                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="zdyfy">
                <pagination class="zdyfy" :background="false" :pageSizes="[10, 20, 30]"  :total="total"
                    :page.sync="queryParams.pageNum" :limit.sync="queryParams.pageSize" @pagination="getList" />
            </div>
        </el-card>

        <el-image-viewer v-if="isOpen" :url-list="activeimgs" @close="closePic" />

    </div>
</template>

<script>
import { activityListAll, activityPage, activityListJoin, activityRelease, activityStop, activityHandleCreate, activityHandleDeleteFile, activityDelete } from "@/api/admin/activity";
import {exportData} from "@/api/demo/data";
import { rateScaleInfo, rateRecordScore, rateRecordScoreInfo } from "@/api/admin/evaluation";
import { timestampToTime } from "@/utils/date";
import { queryDict, userList, fileJoinQueryFile } from "@/api/admin/public";
import previewData from "@/components/previewData.vue";
import { download } from "@/api/adminservice/public";
import { serviceUrl } from "@/utils/global"

export default {
    name: "scenarioMain",
    components: {
        previewData
    },
    data() {
        return {
            role: 1,
            serviceUrl,
            jsHqWidth: 300,
            activeimgs: [],
            isOpen: false,
            isSHowMine: false,
            sbfileList: [],
            delFileList: [],
            toReport: false,
            reportForm: {
                trueName: '',
                mobile: '',
                orgId: '',
                rank: '',
                instructor: '',
                leaveWord: '',
                fileUrls: '',
                activityId: ''
            },
            // 表单校验
            reportRules: {
            },
            selectRow: {},
            scFa: false,
            subjectList: [],
            periodList: [],
            gradeList: [],
            gAFileList: [],
            token: this.$storage.get("token"),
            statusList: [
                { name: '初始阶段', value: 0 },
                { name: '报名阶段', value: 1 },
                { name: '初审阶段', value: 2 },
                { name: '复审阶段', value: 3 },
                { name: '终审阶段', value: 4 },
                { name: '现场评比', value: 5 },
                { name: '活动结束', value: 6 },
            ],
            typeList: [
                { name: '线上培训', value: 0 },
                { name: '线下培训', value: 1 },
            ],
            timestampToTime,
            // 遮罩层
            loading: true,
            // 选中数组
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            isFilter: true,
            // 总条数
            total: 0,
            taskdata: {},
            // 基础：基数数据表格数据
            dataList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                name: '',
                status: '',
                title: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                type: '',
                nature: '',
                pageNum: 1,
                pageSize: 10,
            },
            natureList: [],
            // 表单参数
            form: {},
            activityLevelList: [],
            // 表单校验
            rules: {
                title: [
                    { required: true, message: "请输入标题", trigger: "blur" }
                ],
                values: [
                    { required: true, message: "请输入内容", trigger: "blur" }
                ]
            },
            selectObj: [],
            previewData: {},
            previewShow: false,
            lessonId: '',
            isHide: false,
            disabled: false,
            showFileList: [],
        };
    },
    created() {
        this.getQueryDict()
        this.getList();
        this.role = this.$storage.get("role")
    },
    activated() {
        this.getList();
    },
    watch: {},
    methods: {
        handleManager(row){
            this.$router.push({
                path: "/activityManager",
                query: {
                    activityId: row.activityId,
                }
            });
        },
        xz(e) {
            download(e.fileUrl, e.fileName)
        },
        closePic() {
            this.isOpen = false;
        },
        getShowList(e) {
            this.showFileList = [];
            fileJoinQueryFile({ activityId: e.activityId, type: 3 }).then(res => {
                if (res.data.data) {
                    this.showFileList = res.data.data;
                }

            })
        },
        handleChange(e, type) {
            console.log(e, type)
            if (e.response) {
                if (e.response.code == 1) {
                    this.$message.success('上传成功')
                    this.getList()
                } else {
                    if (e.response.msg) {
                        this.$message.error(e.response.msg)
                    } else {
                        this.$message.error('上传失败')
                    }
                }
            }
            if (e.status == 'fail') {
                this.$message.error('导入失败')
            }
        },
        submitPreviewForm() {
            console.log(this.previewData);
            var obj = {};
            obj.scaleId = this.$refs.editData.previewData.scaleId;
            obj.lessonId = this.lessonId;
            obj.answerList = [];
            if (this.$refs.editData.isHide) {
                obj.isHide = 1;
            } else {
                obj.isHide = 0;
            }
            var totalScore = 0;
            this.$refs.editData.previewData.questionList.forEach(e => {
                if (e.type == 2) {
                    var txt = e.questionAnswer.toString()
                    obj.answerList.push({
                        questionId: e.questionId,
                        questionAnswer: txt
                    })
                    e.questionAnswer.forEach(m => {
                        e.itemList.forEach(j => {
                            if (m == j.itemId) {
                                totalScore += Number(j.itemValue)
                            }
                        })
                    })
                } else {
                    if (e.type == 1) {
                        e.itemList.forEach(j => {
                            if (e.questionAnswer == j.itemId) {
                                totalScore += Number(j.itemValue)
                            }
                        })
                    }
                    if (e.type == 3) {
                        totalScore += Number(e.questionAnswer)
                    }
                    obj.answerList.push({
                        questionId: e.questionId,
                        questionAnswer: e.questionAnswer
                    })
                }

            })
            obj.totalScore = totalScore;

            rateRecordScore(obj).then(res => {
                if (res.data.code == 1) {
                    this.previewShow = false;
                    this.isHide = false;
                    this.$message.success('提交成功')
                    this.getList();
                } else {
                    this.$message.error(res.data.msg)
                }
            })
            console.log(this.previewData);
            console.log(obj);
        },
        closePreview() {
            this.previewShow = false;
        },
        handleComplete(item, row) {
            this.disabled = false;
            if (row.status == 3) {
                this.disabled = true
            }
            this.lessonId = row.activityId;
            this.isHide = false;
            if (item.isSub == 1) {
                rateRecordScoreInfo({ lessonId: this.lessonId, scaleId: item.scaleId }).then(res => {
                    if (res.data.data.info.isHide == 1) {
                        this.isHide = true;
                    }
                    this.previewData = res.data.data.info;
                    this.previewData.questionList.forEach(e => {
                        if (e.type == 2) {
                            e.questionAnswer = e.questionAnswer.split(',');
                        } else {
                            // e.questionAnswer = '';
                        }
                    })
                    this.previewShow = true;
                    console.log(this.previewData);
                })
            } else {
                rateScaleInfo({ scaleId: item.scaleId }).then(res => {
                    this.previewData = res.data.data;
                    this.previewData.questionList.forEach(e => {
                        if (e.type == 2) {
                            e.questionAnswer = [];
                        } else {
                            e.questionAnswer = '';
                        }
                    })
                    this.previewShow = true;
                    console.log(this.previewData);
                })
            }
        },
        handleApply(row) {
            this.reportForm.activityId = row.activityId;
            this.toReport = true;
            this.reportForm.instructor = ''
            this.reportForm.leaveWord = ''
            this.delFileList = [];
        },
        goFileDetail(item) {
            this.activeimgs = []
            if (item.fileType == 'pdf' || item.fileType == 'ppt' || item.fileType == 'pptx' || item.fileType == 'doc' || item.fileType == 'docx') {
                if (item.imgUrl) {
                    console.log(item);
                    let routeUrl = this.$router.resolve({
                        path: '/lessonFileDetail',// 这里的路径就可以正常的写，不需要添加_blank: true
                        query: { data: JSON.stringify(item) }
                    })
                    window.open(routeUrl.href, '_blank')
                } else {
                    this.activeimgs.push(item.fileUrl)
                    this.isOpen = true;
                }
            } else if (item.fileType == 'jpg' || item.fileType == 'jpeg' || item.fileType == 'png') {
                this.activeimgs.push(item.fileUrl)
                this.isOpen = true;
            } else {
                this.xz(item)
            }
        },
        handleDiscuss(row) {
            let routeUrl = this.$router.resolve({
                path: '/lessonDiscuss',// 这里的路径就可以正常的写，不需要添加_blank: true
                query: { lessonId: row.lessonId }
            })
            window.open(routeUrl.href, '_blank')
        },
        handleExceed(e) {
        },
        handleAvatarSuccess(response, uploadFile) {
            if (uploadFile.response.code == 1) {
                this.selectRow.coverUrl = uploadFile.response.data;
            } else {
                this.$message.error("上传失败")
            }

        },
        beforeAvatarUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'image/jpeg' || rawFile.type == 'image/png' || rawFile.type == 'image/jpg')) {
                this.$message.error('图片必须是jpeg、png、jpg格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 10) {
                this.$message.error('图片大小不能超过10M')
                return false
            }
            return true
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                this.periodList = res.data.data;
            })
            queryDict({ code: 'activity_nature' }).then(res => {
                this.natureList = res.data.data;
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey == j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.getList()
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = []
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey == e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey == j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.getList()
        },
        beforeJAUpload(rawFile) {
            console.log(rawFile)
            if (!(rawFile.type == 'application/pdf' || rawFile.type == 'application/vnd.ms-powerpoint' || rawFile.type == 'application/vnd.openxmlformats-officedocument.presentationml.presentation' || rawFile.type == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' || rawFile.type == 'application/msword')) {
                this.$message.error('文件必须是.pdf,.ppt,.pptx,.doc,.docx格式的')
                return false
            } else if (rawFile.size / 1024 / 1024 > 200) {
                this.$message.error('文件大小不能超过200M')
                return false
            }
            return true
        },
        handleCurrentChange(val) {
            console.log(val)
            this.selectObj = val;
        },
        handleSelectionChange(val) {
            console.log(val)
            this.selectList = val;
        },
        tgMethod(e) {
            this.queryParams.screenName = '';
            this.open = false;
            this.taskdata = {};
            this.getList();
        },
        /** 查询基础：基数数据列表 */
        getList(e) {
            this.dataList = []
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            queryDict({ code: 'topic_level' }).then(resb => {
                this.activityLevelList = resb.data.data;
                activityPage(this.queryParams).then(res => {
                    this.total = res.data.data.total;
                    this.dataList = JSON.parse(JSON.stringify(res.data.data.list));
                    this.loading = false;
                });
            })

        },
        /** 删除按钮操作 */
        handleDelete(row) {
            activityDelete({ activityId: row.activityId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("删除成功");
                    this.getList();
                } else {
                    this.$message.error("删除失败");
                }
            })
        },
        goDetail(row) {
            this.$router.push({
                path: "/activityDetail",
                query: {
                    activityId: row.activityId,
                }
            });
        },
        /** 导出按钮操作 */
        handleExport() {
            const queryParams = this.queryParams;
            this.$confirm("是否确认导出所有基础：基数数据数据项?", "警告", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(function () {
                    return exportData(queryParams);
                })
                .then(response => {
                    this.download(response.msg);
                });
        },
        // 表单重置
        reset() {
            this.form = {
                did: null,
                type: null,
                title: null,
                values: null,
                px: null,
                createTime: null,
                updateTime: null,
                delFlag: null
            };
            // this.$refs['form'].resetFields()
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.$refs['queryForm'].resetFields()
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.$router.push({
                path: "/activityCreate",
            });
        },
        handleLbAdd() {
            this.$router.push({
                path: "/activityScale",
            });
        },
        handleRelease(row) {
            activityRelease({ activityId: row.activityId }).then(res => {
                this.loading = true;
                if (res.data.code == 1) {
                    this.$message.success("发布成功");
                    this.getList();
                } else {
                    this.$message.error("发布失败");
                    this.loading = false;
                }
            })
        },
        handleStop(row) {
            activityStop({ activityId: row.activityId }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("停止成功");
                    this.getList();
                } else {
                    this.$message.error("停止失败");
                }
            })
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            this.$router.push({
                path: "/activityCreate",
                query: {
                    activityId: row.activityId,
                }
            });
        }
    }
};
</script>
<style scoped>
.disnone /deep/ .el-upload-list {
    display: none;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

.csbbb {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}

.zdp /deep/ .el-range-editor.el-input__wrapper {
    width: 100%;
}

.zzzdddyyy /deep/ .el-upload-list {
    margin: 0 !important;
}

.zzzdddyyy /deep/ .el-upload-list__item {
    display: none;
}

.pxbutton {
    width: 90px;
    padding: 7px 15px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #e4e7ed;
    font-size: 13px;
}

.filtxt {
    color: #409efe;
    margin: 8px 0;
}

.avatar-uploader .avatar {
    width: 178px;
    height: 178px;
    display: block;
    object-fit: cover;
}

.el-table /deep/ .hidden-row {
    display: none;
}

.avatar-uploader /deep/ .el-upload {
    border: 1px dashed var(--el-border-color);
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
    border-color: var(--el-color-primary);
}
</style>
